import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import {
  addDays,
  endOfMonth,
  format,
  getDay,
  startOfMonth,
} from 'date-fns/esm';
import AvailabilityDate from '../../models/AvailabilityDate';

export class Day {
  date: Date | null;
  info: AvailabilityDate | null;

  constructor(date: Date = null, info: AvailabilityDate = null) {
    this.date = date;
    this.info = info;
  }

  getDay() {
    if (this.date) {
      return format(this.date, 'd');
    } else {
      return null;
    }
  }

  hasBooking(): boolean {
    return !!this.info;
  }

  getInitials(): string {
    return this.info.initials;
  }
}

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarComponent implements OnInit {
  @Input() month: Date;
  @Input() dates: AvailabilityDate[];
  @Input() onSelect = () => {};

  // eslint-disable-next-line @typescript-eslint/member-ordering
  weeks: any[] = [];

  ngOnInit() {
    this.weeks = this.generateMonth();
  }

  trackByWeek(index: number, item: any) {
    return item;
  }

  trackByDay(index: number, item: any) {
    return item;
  }

  getLabel(): string {
    return format(this.month, 'MMMM yyyy');
  }

  generateMonth() {
    const availabilityDates = this.dates.reduce(
      (acc: any, current: AvailabilityDate) => {
        acc[format(new Date(`${current.date}T00:00:00`), 'ddMMyy')] = current;
        return acc;
      },
      {}
    );

    const start = startOfMonth(this.month);
    let processedDay = start;
    let infoDay = start;
    const weeks = [];
    let week = [];
    while (processedDay <= endOfMonth(start)) {
      week = [];
      const day = getDay(processedDay);
      if (day > 0) {
        for (let i = 0; i < day; i++) {
          week.push(new Day());
        }
      }
      for (let i = day; i < 7 && processedDay <= endOfMonth(start); i++) {
        const dayMonthYear = format(infoDay, 'ddMMyy');
        infoDay = addDays(infoDay, 1);
        const info = availabilityDates[dayMonthYear] || null;
        week.push(new Day(processedDay, info));
        processedDay = addDays(processedDay, 1);
      }
      if (getDay(processedDay) === 0) {
        weeks.push(week);
      }
    }
    const _day = getDay(processedDay);
    if (_day > 0) {
      for (let i = _day; i < 7; i++) {
        week.push(new Day());
      }
      weeks.push(week);
    }
    return weeks;
  }
}
